import { ReactNode } from "react";
import { Card, Typography } from "@mui/material";
import { radius } from "../../data/tokens";

// Card base do dashboard: sem sombra e sem borda (fundo branco sobre
// o fundo lavanda da página), cantos arredondados e altura total.
export function DashCard({
  title,
  children,
}: {
  title?: string;
  children: ReactNode;
}) {
  return (
    <Card sx={{ height: "100%", p: 2.5, borderRadius: `${radius.lg}px` }}>
      {title && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {title}
        </Typography>
      )}
      {children}
    </Card>
  );
}
